import React, { useEffect, useState } from 'react';
import {Redirect} from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import PropTypes from 'prop-types';
import Alert from 'react-bootstrap/Alert';
import StaticNav from '../common/StaticNav';
import { longButtonStyle, wizzardBarStyle, TitleBar, IconCheck, IconClose, IconCircle, IconSelected, evenRowColor, IconDownload } from '../common/theme';
import { toTimeType, toTime, uploadCSV, isObjectEmpty, toArray } from '../../Utils';
import DateSelectorComp from '../common/DateSelectorComp';
import ViewReportsPage from './ViewReportsPage';
import Modal from 'react-bootstrap/Modal';
import Spinner from '../common/generic/Spinner';
import ErrorDialog from '../common/ErrorDialog';

function StudentReportTableComp({pageState}) {
  const [csvData, setcsvData] = useState({});
  const [loadingCSV, setloadingCSV] = useState({
          skills:false, class:false, pretest:false, posttest:false, hotspot:false, activity:false, unit:false,
          MMMasteredFacts:false, MMPretests:false, MMDay:false, MMMonth:false, MMStatus:false, MMStatusMonth:false,
          lessonMarks:false, courseMarks:false, courseAnswers:false
        });
  const [dialog, setDialog] = useState({show:false});
  const [dialogError, setDialogError] = useState({show:false});
  const [disableReportButton, setDisableReportButton] = useState(true);
  const [loadingLessonCount, setLoadingLessonCount]= useState(-1);

  const titleRow = <TitleBar>
      <Col xs='2'> Students <br/><Button variant={'success'} onClick={()=>selectAll()}><IconCheck/></Button> 	&nbsp; <Button variant={'success'} onClick={()=>unselectAll()}><IconClose/></Button> </Col>
      <Col style={{paddingTop:'15px'}} xs='2'> <Button variant={'warning'} disabled={disableReportButton} onClick={()=>openDialog()}>View Reports</Button></Col>
      <Col xs='1'>Completed<br/>Pretest</Col>
      <Col xs='2'>Time<br/>Spent</Col>
      <Col xs='2'>Activities<br/>Mastered</Col>
      <Col xs='2'>Questions<br/>Attempted</Col>
      <Col xs='1'><br/>Score</Col>
  </TitleBar>;

  useEffect(() => {
    if(!pageState.database['getCustomer'])
      return pageState.sethasDatabaseData(false);
  },[]);
  
  useEffect(()=>{
    let progIdx = pageState.processedProgramSummary.findIndex(el => el.id === pageState.selectedProgram.id);
    let shouldDisableButtons = pageState.processedProgramSummary[progIdx].students.reduce((acc,e)=>{if(e.isSelected) acc=false; return acc;},true);
    setDisableReportButton(shouldDisableButtons);
  },[pageState.processedProgramSummary]);

  if (!pageState.hasDatabaseData) {
    return <Redirect to='/' />;
  }

  const openReportsPage=(reportType)=>{
    let theClass = pageState.database['getAllClasses'].data[pageState.classID];
    let masterLevel = theClass['MasterLevel'];

    localStorage.setItem('reportData', JSON.stringify({reportType,masterLevel,classID:pageState.classID,token:sessionStorage.getItem('token'),selectedStudents:[...pageState.selectedStudents],selectedProgram: pageState.selectedProgram}));
    let newWin = window.open('/viewreports/index.html', '_blank');
    if(!newWin || !newWin.document.write || newWin.closed || typeof newWin.closed=='undefined') 
    { 
        setDialogError({title:'Problem showing reports', text:'Please turn off your pop-up blocker to see the reports', show:true});
    }
  };

  const openCSVPage=(reportType)=>{
    let theClass = pageState.database['getAllClasses'].data[pageState.classID];
    let masterLevel = theClass['MasterLevel'];
    localStorage.setItem('reportData', JSON.stringify({reportType,masterLevel,classID:pageState.classID,token:sessionStorage.getItem('token'),selectedStudents:[...pageState.selectedStudents],selectedProgram: pageState.selectedProgram}));

    // tell edge users they have to use Chrome
    if (document.documentMode || /Edge/.test(navigator.userAgent)) {
      window.alert('Sorry, this feature is not supported on Edge browsers, please use Chrome or FireFox');
      return;
    }

    // stop iOS devices from saving
    if(!!navigator.platform.match(/iPhone|iPod|iPad/)){
      window.alert('Sorry, this feature is not supported on iOS devices, please use a desktop computer');
      return;
    }

    if(reportType==='Skills') setloadingCSV({...loadingCSV, skills:true});
    if(reportType==='Activity') setloadingCSV({...loadingCSV, activity:true});
    if(reportType==='Unit') setloadingCSV({...loadingCSV, unit:true});
    if(reportType==='Class') setloadingCSV({...loadingCSV, class:true});
    if(reportType==='Pretest') setloadingCSV({...loadingCSV, pretest:true});
    if(reportType==='Posttest') setloadingCSV({...loadingCSV, posttest:true});
    if(reportType==='HotSpot') setloadingCSV({...loadingCSV, hotspot:true});    

    if(reportType==='MMMasteredFacts') setloadingCSV({...loadingCSV, MMMasteredFacts:true});
    if(reportType==='MMPretests') setloadingCSV({...loadingCSV, MMPretests:true});
    if(reportType==='MMDay') setloadingCSV({...loadingCSV, MMDay:true});
    if(reportType==='MMMonth') setloadingCSV({...loadingCSV, MMMonth:true});
    if(reportType==='MMStatus') setloadingCSV({...loadingCSV, MMStatus:true});
    if(reportType==='MMStatusMonth') setloadingCSV({...loadingCSV, MMStatusMonth:true});

    if(reportType==='LessonMarks') setloadingCSV({...loadingCSV, lessonMarks:true});
    if(reportType==='LessonStandards') setloadingCSV({...loadingCSV, lessonStandards:true});
    if(reportType==='LessonLessons') setloadingCSV({...loadingCSV, lessonLessons:true});
    if(reportType==='LessonAnswers') setloadingCSV({...loadingCSV, lessonAnswers:true});

    if(reportType==='CourseMarks') setloadingCSV({...loadingCSV, courseMarks:true});
    if(reportType==='CourseAnswers') setloadingCSV({...loadingCSV, courseAnswers:true});

    setcsvData({processStage:'newRequest', loadingCSV, setloadingCSV, reportType, selectedStudents:[...pageState.selectedStudents],selectedProgram: pageState.selectedProgram});
  };

  const closeStudentsTable = () => {
    let programID = pageState.selectedProgram.id;
    let nextState = [...pageState.processedProgramSummary];
    let index = nextState.findIndex(el => el.id === programID);
    nextState[index].students = nextState[index].students.map(e=>{e.isSelected=false;return e;}); 
    nextState[index] = {...nextState[index], showStudents: false};
    pageState.setProcessedProgramSummary(nextState);
    pageState.setSelectedProgram({});
    pageState.setSelectedStudents([]);
  };

  const openDialog =()=>{
    let type = 'DEFAULT';
    if (pageState.selectedProgram.name==='Mad Minute Math') type = 'MADMINUTE';
    if (pageState.selectedProgram.id.startsWith('QUIZ')) type = 'QUIZ';
    if (pageState.selectedProgram.id.startsWith('LESSON')) type = 'LESSON';
    if (pageState.selectedProgram.id.startsWith('COURSE')) type = 'COURSE';
    setDialog({title:`${pageState.selectedProgram.name}`, type, show:true});
  };
  
  const selectAll = () => {
    let stateData = pageState.processedProgramSummary;
    let progIdx = stateData.findIndex(el => el.id === pageState.selectedProgram.id);
    let progState = {...stateData[progIdx]};
    progState.students = [...progState.students].map(el=>{return{...el, isSelected:true};});
    stateData[progIdx] = progState;
    pageState.setProcessedProgramSummary([...stateData]);
    pageState.setSelectedStudents([...toArray(progState.students)].map(el=>{return{id:el.StudentID,name:el.Name};}));
  };

  const unselectAll = () => {
    let stateData = pageState.processedProgramSummary;
    let progIdx = stateData.findIndex(el => el.id === pageState.selectedProgram.id);
    let progState = {...stateData[progIdx]};
    progState.students = [...progState.students].map(el=>{return{...el, isSelected:false};});
    stateData[progIdx] = progState;
    pageState.setProcessedProgramSummary([...stateData]);
    pageState.setSelectedStudents([]);
  };

  return (
    (!pageState.classID)?<>Please add some classes</>:
    <div>
      <StaticNav currentTopic={'Reports'}/>
      <Button onClick={closeStudentsTable} variant="danger" >Back</Button>
      <Row>
      <Col xs={12}>
          <br/>
          <Row>  
            <Col xs='12' style={{fontWeight:'bold'}}> <h2> {pageState.selectedProgram.name} </h2></Col> 
            {/* <Col xs='6'><Alert style={longButtonStyle} variant={'success'}> Please select one or more students and press &nbsp;&nbsp; <Button variant={'warning'} disabled={disableReportButton} onClick={openDialog}>View Reports</Button> </Alert></Col> */}
          </Row> 
          <Row style={wizzardBarStyle}> <h5>  &nbsp; 1) Select One or More Students & Press View Reports </h5></Row>
          <DateSelectorComp pageState={pageState}/> <br/>

          {titleRow} 
          {pageState.processedProgramSummary.map((programRec, pi) => <span key={pi}>
              {programRec.showStudents && programRec.students.map((studentRec, si) => 
                  <StudentRow key={si} index={si} pageState={pageState} studentState={studentRec} />
              )}
              </span>
          )}
      </Col>
      <Col xs={12} style={{marginTop:'10px'}}><Button variant={'warning'} disabled={disableReportButton} onClick={openDialog}>View Reports</Button></Col>
      </Row>
      <br/>
      {(!isObjectEmpty(csvData)) && <ViewReportsPage loadingLessonCount={loadingLessonCount} setLoadingLessonCount={setLoadingLessonCount} csvData={csvData} setcsvData={setcsvData}/>}
      <Dialog dialogState={{dialog, setDialog}} loadingLessonCount={loadingLessonCount} loadingCSV={{loadingCSV, setloadingCSV}} pageState={pageState} openCSVPage={openCSVPage} openReportsPage={openReportsPage}/>
      <ErrorDialog dialogState={{dialogError, setDialogError}} />
    </div>
  );
}

const Dialog=({dialogState, loadingCSV, pageState, openCSVPage, openReportsPage, loadingLessonCount})=> {

  const {dialog, setDialog} = dialogState;    
  const {title, type, show} = dialog;

  const closeHandler=()=>{
      setDialog({show:false});
  };

  return (
      <>
      <Modal show={show} onHide={closeHandler}>
          <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {(type === 'DEFAULT') && <Console pageState={pageState} loadingCSV={loadingCSV} openCSVPage={openCSVPage} openReportsPage={openReportsPage} /> }
            {(type === 'MADMINUTE') && <MMConsole pageState={pageState} loadingCSV={loadingCSV} openCSVPage={openCSVPage} openReportsPage={openReportsPage} /> }
            {(type === 'QUIZ') && <LessonConsole pageState={pageState} loadingLessonCount={loadingLessonCount} loadingCSV={loadingCSV} openCSVPage={openCSVPage} openReportsPage={openReportsPage} /> }
            {(type === 'LESSON') && <LessonConsole pageState={pageState} loadingLessonCount={loadingLessonCount} loadingCSV={loadingCSV} openCSVPage={openCSVPage} openReportsPage={openReportsPage} /> }
            {(type === 'COURSE') && <CourseConsole pageState={pageState} loadingLessonCount={loadingLessonCount} loadingCSV={loadingCSV} openCSVPage={openCSVPage} openReportsPage={openReportsPage} /> }
          </Modal.Body>
          <Modal.Footer>
          <Button variant="secondary" onClick={closeHandler}>
              Close
          </Button>
          </Modal.Footer>
      </Modal>
      </>
  );
};

const Console = ({pageState, loadingCSV, openCSVPage, openReportsPage}) =>{
  const extraMessage = () =>{
    // tell edge users they have to use Chrome
    if (document.documentMode || /Edge/.test(navigator.userAgent)) {
      return 'Note: The download feature is not supported on Edge browsers, please use Chrome or FireFox';
    }

    // stop iOS devices from saving
    if(!!navigator.platform.match(/iPhone|iPod|iPad/)){
      return 'Note: The download feature is not supported on iOS devices, please use a desktop computer';
    }

    return '';
  };

  const isDisabled =()=>{
    return loadingCSV.loadingCSV.skills || 
          loadingCSV.loadingCSV.activity ||
          loadingCSV.loadingCSV.unit ||
          loadingCSV.loadingCSV.hotspot ||
          loadingCSV.loadingCSV.prettest ||
          loadingCSV.loadingCSV.posttest ||
          loadingCSV.loadingCSV.class || 

          loadingCSV.loadingCSV.MMMasteredFacts || 
          loadingCSV.loadingCSV.MMPretests ||
          loadingCSV.loadingCSV.MMDay ||
          loadingCSV.loadingCSV.MMMonth ||
          loadingCSV.loadingCSV.MMStatus ||
          loadingCSV.loadingCSV.MMStatusMonth ||
          
          loadingCSV.loadingCSV.lessonMarks ||
          loadingCSV.loadingCSV.lessonStandards ||
          loadingCSV.loadingCSV.lessonLessons ||
          loadingCSV.loadingCSV.lessonAnswers ||
          
          loadingCSV.loadingCSV.courseMarks ||
          loadingCSV.loadingCSV.courseAnswers;   
  };
  return(
  <>
    <Row><Alert style={longButtonStyle} variant={'success'}> Choose a report type to view reports or press download to save to csv. Please turn off any pop-up blockers before continuing.  <strong>{extraMessage()}</strong> </Alert></Row>
    <Row>
      <Col xs={8}><Button style={longButtonStyle} onClick={()=>openReportsPage('Skills')} variant="info"> View Skill Report </Button></Col>
      <Col xs={4}><Button disabled={isDisabled()} style={longButtonStyle} onClick={()=>openCSVPage('Skills')} variant="success"> {(loadingCSV.loadingCSV.skills) ? <center><Spinner/>({pageState.database['queryCount']})</center>: <><IconDownload/> Download</>} </Button></Col>
    </Row>
    <Row>
      <Col xs={8}><Button style={longButtonStyle} onClick={()=>openReportsPage('Activity')} variant="info"> View Activity Report </Button></Col>
      <Col xs={4}><Button disabled={isDisabled()} style={longButtonStyle} onClick={()=>openCSVPage('Activity')} variant="success"> {(loadingCSV.loadingCSV.activity) ? <center><Spinner/>({pageState.database['queryCount']})</center> : <><IconDownload/> Download</>} </Button></Col>
    </Row>
    <Row>
      <Col xs={8}><Button style={longButtonStyle} onClick={()=>openReportsPage('Unit')} variant="info"> View Unit Report </Button></Col>
      <Col xs={4}><Button disabled={isDisabled()} style={longButtonStyle} onClick={()=>openCSVPage('Unit')} variant="success"> {(loadingCSV.loadingCSV.unit) ? <center><Spinner/>({pageState.database['queryCount']})</center> : <><IconDownload/> Download</>} </Button></Col>
    </Row>
    <Row>
      <Col xs={8}><Button style={longButtonStyle} onClick={()=>openReportsPage('HotSpot')} variant="info"> View Hot-Spot Report </Button></Col>
      <Col xs={4}><Button disabled={isDisabled()} style={longButtonStyle} onClick={()=>openCSVPage('HotSpot')} variant="success"> {(loadingCSV.loadingCSV.hotspot) ? <center><Spinner/>({pageState.database['queryCount']})</center> : <><IconDownload/> Download</>} </Button></Col>
    </Row>
    <Row>
      <Col xs={8}><Button style={longButtonStyle} onClick={()=>openReportsPage('Pretest')} variant="info"> View Pre-Test Report </Button></Col>
      <Col xs={4}><Button disabled={isDisabled()} style={longButtonStyle} onClick={()=>openCSVPage('Pretest')} variant="success"> {(loadingCSV.loadingCSV.pretest) ? <center><Spinner/>({pageState.database['queryCount']})</center> : <><IconDownload/> Download</>} </Button></Col>
    </Row>
    <Row>
      <Col xs={8}><Button style={longButtonStyle} onClick={()=>openReportsPage('Posttest')} variant="info"> View Post-Test Report  </Button></Col>
      <Col xs={4}><Button disabled={isDisabled()} style={longButtonStyle} onClick={()=>openCSVPage('Posttest')} variant="success"> {(loadingCSV.loadingCSV.posttest) ? <center><Spinner/>({pageState.database['queryCount']})</center> : <><IconDownload/> Download</>} </Button></Col>
    </Row>
    <Row>
      <Col xs={8}><Button style={longButtonStyle} onClick={()=>openReportsPage('Class')} variant="info"> View Mastery Report  </Button></Col>
      <Col xs={4}><Button disabled={isDisabled()} style={longButtonStyle} onClick={()=>openCSVPage('Class')} variant="success"> {(loadingCSV.loadingCSV.class) ? <center><Spinner/>({pageState.database['queryCount']})</center> : <><IconDownload/> Download</>} </Button></Col>
    </Row>    
  </>);
};

const MMConsole = ({pageState, loadingCSV, openCSVPage, openReportsPage}) =>{
  const extraMessage = () =>{
    // tell edge users they have to use Chrome
    if (document.documentMode || /Edge/.test(navigator.userAgent)) {
      return 'Note: The download feature is not supported on Edge browsers, please use Chrome or FireFox';
    }

    // stop iOS devices from saving
    if(!!navigator.platform.match(/iPhone|iPod|iPad/)){
      return 'Note: The download feature is not supported on iOS devices, please use a desktop computer';
    }

    return '';
  };

  const isDisabled =()=>{
    return loadingCSV.loadingCSV.skills || 
          loadingCSV.loadingCSV.activity ||
          loadingCSV.loadingCSV.unit ||
          loadingCSV.loadingCSV.hotspot ||
          loadingCSV.loadingCSV.prettest ||
          loadingCSV.loadingCSV.posttest ||
          loadingCSV.loadingCSV.class || 

          loadingCSV.loadingCSV.MMMasteredFacts || 
          loadingCSV.loadingCSV.MMPretests ||
          loadingCSV.loadingCSV.MMDay ||
          loadingCSV.loadingCSV.MMMonth ||
          loadingCSV.loadingCSV.MMStatus ||
          loadingCSV.loadingCSV.MMStatusMonth ||
          
          loadingCSV.loadingCSV.lessonMarks ||
          loadingCSV.loadingCSV.lessonStandards ||
          loadingCSV.loadingCSV.lessonLessons ||          
          loadingCSV.loadingCSV.lessonAnswers ||
          
          loadingCSV.loadingCSV.courseMarks ||
          loadingCSV.loadingCSV.courseAnswers;
  };
 
  return(
  <>
    <Row><Alert style={longButtonStyle} variant={'success'}> Choose a report type to view reports or press download to save to csv. Please turn off any pop-up blockers before continuing.  <strong>{extraMessage()}</strong> </Alert></Row>
    <Row>
      <Col xs={8}><Button style={longButtonStyle} onClick={()=>openReportsPage('MMMasteredFacts')} variant="info"> Mastered Facts </Button></Col>
      <Col xs={4}><Button disabled={isDisabled()} style={longButtonStyle} onClick={()=>openCSVPage('MMMasteredFacts')} variant="success"> {(loadingCSV.loadingCSV.MMMasteredFacts) ? <center><Spinner/>({pageState.database['queryCount']})</center>: <><IconDownload/> Download</>} </Button></Col>
    </Row>
    <Row>
      <Col xs={8}><Button style={longButtonStyle} onClick={()=>openReportsPage('MMPretests')} variant="info"> Pretest Report </Button></Col>
      <Col xs={4}><Button disabled={isDisabled()} style={longButtonStyle} onClick={()=>openCSVPage('MMPretests')} variant="success"> {(loadingCSV.loadingCSV.MMPretests) ? <center><Spinner/>({pageState.database['queryCount']})</center> : <><IconDownload/> Download</>} </Button></Col>
    </Row>
    <Row>
      <Col xs={8}><Button style={longButtonStyle} onClick={()=>openReportsPage('MMDay')} variant="info"> Report by Day </Button></Col>
      <Col xs={4}><Button disabled={isDisabled()} style={longButtonStyle} onClick={()=>openCSVPage('MMDay')} variant="success"> {(loadingCSV.loadingCSV.MMDay) ? <center><Spinner/>({pageState.database['queryCount']})</center> : <><IconDownload/> Download</>} </Button></Col>
    </Row>
    <Row>
      <Col xs={8}><Button style={longButtonStyle} onClick={()=>openReportsPage('MMMonth')} variant="info"> Report by Month </Button></Col>
      <Col xs={4}><Button disabled={isDisabled()} style={longButtonStyle} onClick={()=>openCSVPage('MMMonth')} variant="success"> {(loadingCSV.loadingCSV.MMMonth) ? <center><Spinner/>({pageState.database['queryCount']})</center> : <><IconDownload/> Download</>} </Button></Col>
    </Row>
    <Row>
      <Col xs={8}><Button style={longButtonStyle} onClick={()=>openReportsPage('MMStatus')} variant="info"> Status Report - Cumulative </Button></Col>
      <Col xs={4}><Button disabled={isDisabled()} style={longButtonStyle} onClick={()=>openCSVPage('MMStatus')} variant="success"> {(loadingCSV.loadingCSV.MMStatus) ? <center><Spinner/>({pageState.database['queryCount']})</center> : <><IconDownload/> Download</>} </Button></Col>
    </Row>
    <Row>
      <Col xs={8}><Button style={longButtonStyle} onClick={()=>openReportsPage('MMStatusMonth')} variant="info"> Status Report - Last 30 days </Button></Col>
      <Col xs={4}><Button disabled={isDisabled()} style={longButtonStyle} onClick={()=>openCSVPage('MMStatusMonth')} variant="success"> {(loadingCSV.loadingCSV.MMStatusMonth) ? <center><Spinner/>({pageState.database['queryCount']})</center> : <><IconDownload/> Download</>} </Button></Col>
    </Row>  
  </>);
};

const LessonConsole = ({pageState, loadingCSV, openCSVPage, openReportsPage, loadingLessonCount}) =>{
  const extraMessage = () =>{
    // tell edge users they have to use Chrome
    if (document.documentMode || /Edge/.test(navigator.userAgent)) {
      return 'Note: The download feature is not supported on Edge browsers, please use Chrome or FireFox';
    }

    // stop iOS devices from saving
    if(!!navigator.platform.match(/iPhone|iPod|iPad/)){
      return 'Note: The download feature is not supported on iOS devices, please use a desktop computer';
    }

    return '';
  };

  const isDisabled =()=>{
    return loadingCSV.loadingCSV.skills || 
          loadingCSV.loadingCSV.activity ||
          loadingCSV.loadingCSV.unit ||
          loadingCSV.loadingCSV.hotspot ||
          loadingCSV.loadingCSV.prettest ||
          loadingCSV.loadingCSV.posttest ||
          loadingCSV.loadingCSV.class || 

          loadingCSV.loadingCSV.MMMasteredFacts || 
          loadingCSV.loadingCSV.MMPretests ||
          loadingCSV.loadingCSV.MMDay ||
          loadingCSV.loadingCSV.MMMonth ||
          loadingCSV.loadingCSV.MMStatus ||
          loadingCSV.loadingCSV.MMStatusMonth ||
          
          loadingCSV.loadingCSV.lessonMarks ||
          loadingCSV.loadingCSV.lessonStandards ||
          loadingCSV.loadingCSV.lessonLessons ||
          loadingCSV.loadingCSV.lessonAnswers;  
  };
 
  return(
  <>
    <Row><Alert style={longButtonStyle} variant={'success'}> Choose a report type to view reports or press download to save to csv. Please turn off any pop-up blockers before continuing.  <strong>{extraMessage()}</strong> </Alert></Row>
    <Row>
      <Col xs={8}><Button style={longButtonStyle} onClick={()=>openReportsPage('LessonMarks')} variant="info"> Marks </Button></Col>
      <Col xs={4}><Button disabled={isDisabled()} style={longButtonStyle} onClick={()=>openCSVPage('LessonMarks')} variant="success"> {(loadingCSV.loadingCSV.lessonMarks) ? <center><Spinner/>({loadingLessonCount})</center>: <><IconDownload/> Download</>} </Button></Col>
    </Row>
    <Row>
      <Col xs={8}><Button style={longButtonStyle} onClick={()=>openReportsPage('LessonLessons')} variant="info"> Lessons </Button></Col>
      <Col xs={4}><Button disabled={isDisabled()} style={longButtonStyle} onClick={()=>openCSVPage('LessonLessons')} variant="success"> {(loadingCSV.loadingCSV.lessonLessons) ? <center><Spinner/>({loadingLessonCount})</center>: <><IconDownload/> Download</>} </Button></Col>
    </Row>
    <Row>
      <Col xs={8}><Button style={longButtonStyle} onClick={()=>openReportsPage('LessonStandards')} variant="info"> Standards </Button></Col>
      <Col xs={4}><Button disabled={isDisabled()} style={longButtonStyle} onClick={()=>openCSVPage('LessonStandards')} variant="success"> {(loadingCSV.loadingCSV.lessonStandards) ? <center><Spinner/>({loadingLessonCount})</center>: <><IconDownload/> Download</>} </Button></Col>
    </Row>
    <Row>
      <Col xs={8}><Button style={longButtonStyle} onClick={()=>openReportsPage('LessonAnswers')} variant="info"> Answers </Button></Col>
      <Col xs={4}><Button disabled={isDisabled()} style={longButtonStyle} onClick={()=>openCSVPage('LessonAnswers')} variant="success"> {(loadingCSV.loadingCSV.lessonAnswers) ? <center><Spinner/>({loadingLessonCount})</center>: <><IconDownload/> Download</>} </Button></Col>
    </Row>
  </>);
};


const CourseConsole = ({pageState, loadingCSV, openCSVPage, openReportsPage, loadingLessonCount}) =>{
  const extraMessage = () =>{
    // tell edge users they have to use Chrome
    if (document.documentMode || /Edge/.test(navigator.userAgent)) {
      return 'Note: The download feature is not supported on Edge browsers, please use Chrome or FireFox';
    }

    // stop iOS devices from saving
    if(!!navigator.platform.match(/iPhone|iPod|iPad/)){
      return 'Note: The download feature is not supported on iOS devices, please use a desktop computer';
    }

    return '';
  };

  const isDisabled =()=>{
    return loadingCSV.loadingCSV.skills || 
          loadingCSV.loadingCSV.activity ||
          loadingCSV.loadingCSV.unit ||
          loadingCSV.loadingCSV.hotspot ||
          loadingCSV.loadingCSV.prettest ||
          loadingCSV.loadingCSV.posttest ||
          loadingCSV.loadingCSV.class || 

          loadingCSV.loadingCSV.MMMasteredFacts || 
          loadingCSV.loadingCSV.MMPretests ||
          loadingCSV.loadingCSV.MMDay ||
          loadingCSV.loadingCSV.MMMonth ||
          loadingCSV.loadingCSV.MMStatus ||
          loadingCSV.loadingCSV.MMStatusMonth ||
          
          loadingCSV.loadingCSV.lessonMarks ||
          loadingCSV.loadingCSV.lessonStandards ||
          loadingCSV.loadingCSV.lessonLessons ||
          loadingCSV.loadingCSV.lessonAnswers ||
          
          loadingCSV.loadingCSV.courseMarks ||
          loadingCSV.loadingCSV.courseAnswers;  
  };
 
  return(
  <>
    <Row><Alert style={longButtonStyle} variant={'success'}> Choose a report type to view reports or press download to save to csv. Please turn off any pop-up blockers before continuing.  <strong>{extraMessage()}</strong> </Alert></Row>
    <Row>
      <Col xs={8}><Button style={longButtonStyle} onClick={()=>openReportsPage('CourseMarks')} variant="info"> Marks </Button></Col>
      <Col xs={4}><Button disabled={isDisabled()} style={longButtonStyle} onClick={()=>openCSVPage('CourseMarks')} variant="success"> {(loadingCSV.loadingCSV.lessonMarks) ? <center><Spinner/>({loadingLessonCount})</center>: <><IconDownload/> Download</>} </Button></Col>
    </Row>
    <Row>
      <Col xs={8}><Button style={longButtonStyle} onClick={()=>openReportsPage('CourseAnswers')} variant="info"> Quiz Answers </Button></Col>
      <Col xs={4}><Button disabled={isDisabled()} style={longButtonStyle} onClick={()=>openCSVPage('CourseAnswers')} variant="success"> {(loadingCSV.loadingCSV.lessonMarks) ? <center><Spinner/>({loadingLessonCount})</center>: <><IconDownload/> Download</>} </Button></Col>
    </Row>    
  </>);
};

const StudentRow = ({studentState, pageState, index}) =>{
    const {StudentID, Name: name, QuestionsRight, QuestionsAttempted, TimesMastered, score, timeSpent, isSelected} = studentState;

    const selectedStyle = (isSelected) ? {backgroundColor:'lightblue'} : (index%2==0)?{background:evenRowColor}:{};

    const toggleSelect = (studID) => {
      let stateData = pageState.processedProgramSummary;
      let progIdx = stateData.findIndex(el => el.id === pageState.selectedProgram.id);
      let progState = {...stateData[progIdx]};
      let studIdx = progState.students.findIndex(el => el.StudentID === studID);
      progState.students[studIdx] = {...progState.students[studIdx], isSelected: !progState.students[studIdx].isSelected};
      stateData[progIdx] = progState;
      pageState.setProcessedProgramSummary([...stateData]);

      if(progState.students[studIdx].isSelected){
        let newState = [...pageState.selectedStudents];        
        newState.push({id:StudentID, name});
        pageState.setSelectedStudents(newState);
      }
      else{
        pageState.setSelectedStudents(pageState.selectedStudents.filter(e=>e.id!==StudentID));
      }
    };

    return(
        <Row style={selectedStyle}>
            {/* <Col xs='4' onClick={() => toggleSelect(id, progID)} style={{paddingLeft: '2em', cursor: 'pointer'}} ><IconSelected isSelected={isSelected}/> {name}</Col> */}
            <Col xs='4' onClick={() => toggleSelect(StudentID)}  style={{paddingLeft: '2em', cursor: 'pointer'}} > {name}</Col>
            <Col style={{textAlign: 'center'}} xs='1'>{(studentState.hasFinishedPretest)&&<IconCircle style={{color: 'green', fontSize: '10px' }}/>}</Col>
            <Col style={{textAlign: 'center'}} xs='2'>{toTime(timeSpent)} {toTimeType(timeSpent)}</Col>
            <Col style={{textAlign: 'center'}} xs='2'>{TimesMastered}</Col>
            <Col style={{textAlign: 'center'}} xs='2'>{QuestionsRight} / {QuestionsAttempted}</Col>
            <Col style={{textAlign: 'center'}} xs='1'>{score}{score!=='--' && <>%</>}</Col>
        </Row>
    );
};

StudentRow.propTypes = {
    data: PropTypes.object,
    state: PropTypes.object,
    progID: PropTypes.string
};
// StudentReportTableComp.propTypes = {
//   isAdmin: PropTypes.bool.isRequired,
// };

export default StudentReportTableComp;